import { defineMessages } from '@/i18n'

export const messages = defineMessages({
  ru: {
    pickGradient: 'Выбрать градиент',
    removeGradient: 'Удалить градиент',
    color1: 'Цвет 1',
    color2: 'Цвет 2',
    swapColors: 'Поменять цвета местами',
    angle: (deg: number) => `Угол: ${deg}°`,
    saveGradient: 'Сохранить градиент',
  },
  en: {
    pickGradient: 'Choose a gradient',
    removeGradient: 'Remove gradient',
    color1: 'Color 1',
    color2: 'Color 2',
    swapColors: 'Swap colors',
    angle: (deg: number) => `Angle: ${deg}°`,
    saveGradient: 'Save gradient',
  },
})
